module.exports = __webpack_public_path__ + "static/media/AccesoCrediticio.c116d926.jfif";